import script from "./StudentDiscipline.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentDiscipline.vue?vue&type=script&setup=true&lang=js"

import "./StudentDiscipline.vue?vue&type=style&index=0&id=f317f692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f317f692"]])

export default __exports__